<template>
  <div>
    <b-modal @show="shown" id="modalEditTelephoneZones" ref="modalEditTelephoneZones" :title="$t('Telephone zones detail')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.zone_id > 0">
          <b-form-input type="text" disabled v-model="editItem.zone_id"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="listOfTypeTelZones" v-model="editItem.type"/>
        </b-form-group>

        <md-button class="md-raised" @click="showAddTelDirections" v-if="editItem.zone_id > 0">{{ $t('Add direction') }}</md-button>

        <b-table striped hover v-if="editItem.zone_id > 0" small
          :items="editItem.directions"
          :fields="directionsFields">
          <template v-slot:cell(actions)="row">
            <i @click.stop="ClickOnDeleteDirectionsButton(row)" class="danger fa fa-trash-alt fa-lg" />
          </template>
        </b-table>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditTelephoneZones')" size="md"/>
      </div>
    </b-modal>

    <b-modal ref="modalAddTelephoneDirections" id="modalAddTelephoneDirections" hide-footer :title="$t('Telephone directions')" size="xl">
        <table-manager-search @filterChanged="filterChanged" :options="options"/>
        <b-form-checkbox  size="md" switch v-model="isShowBusyDirections">{{$t('Show busy directions')}}</b-form-checkbox>

        <b-table striped hover  responsive small
        :items="telDirectionsItems"
        :fields="telDirectionsFields"
        selectable
        select-mode="single"
        @row-clicked="rowClickTerDir">
        </b-table>

        <table-manager-bottom
          :totalRows="telDirectionsTotal" :perPage="perPage"
          v-model="currentPage"/>

        <modal-ok-cancel @save="addTelDirections" @cancel="$bvModal.hide('modalAddTelephoneDirections')" size="lg"/>
      </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      isShowBusyDirections: false,
      listOfTypeTelZones: [
        {text: this.$i18n.t('Local coverage'), value: 0},
        {text: this.$i18n.t('Innerzone coverage'), value: 1},
        {text: this.$i18n.t('Intercity coverage'), value: 2},
        {text: this.$i18n.t('International coverage'), value: 3}
      ],
      selectTelDir: null,
      deleteImage: require('@/assets/img/document_delete.png'),
      directionsFields: [
        {key: 'dir_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      telDirectionsFields: [
        {key: 'dir_id', label: 'ID'},
        {key: 'name', label: this.$i18n.t('Name')},
        {key: 'create_date', label: this.$i18n.t('Created on'), formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'update_date', label: this.$i18n.t('Updated on'), formatter: (val, key, item) => { return val ? this.$root.showDataWithTZDelta(val) : this.$i18n.t('Not installed') }},
        {key: 'zones', label: this.$i18n.t('Zone')},
        {key: 'calling_prefix', label: this.$i18n.t('Calling prefix')},
        {key: 'called_prefix', label: this.$i18n.t('Called prefix')}
      ],
      options: {
        isShowAddButton: false
      },
      filter: '',
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dirrectionsToDelete: []
    }
  },
  methods: {
    async save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }

      if (this.dirrectionsToDelete.length > 0) {
        for (let el of this.dirrectionsToDelete) {
          let tmp = JSON.parse(JSON.stringify(el))
          tmp.zone_id = 0
          tmp.type = 0
          let response = this.$store.dispatch('Tariffing/UPDATE_TEL_DIRECTIONS', tmp)
          response.then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            }
          })
        }
      }

      if (this.editItem.directions.length > 0) {
        for (let el of this.editItem.directions) {
          el.zone_id = this.editItem.zone_id
          el.type = this.editItem.type
          let response = this.$store.dispatch('Tariffing/UPDATE_TEL_DIRECTIONS', el)
          response.then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            }
          })
        }
      }
      let response = this.editItem.zone_id !== 0
        ? this.$store.dispatch('Tariffing/UPDATE_TEL_ZONES', this.editItem)
        : this.$store.dispatch('Tariffing/CREATE_TEL_ZONES', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_TEL_ZONES')
          this.$refs.modalEditTelephoneZones.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    rowClickTerDir (row) {
      this.selectTelDir = row
    },
    showAddTelDirections () {
      this.selectTelDir = null
      this.$refs.modalAddTelephoneDirections.show()
    },
    ClickOnDeleteDirectionsButton (row) {
      this.dirrectionsToDelete.push(row.item)
      this.editItem.directions = this.editItem.directions.filter((value) => {
        return value !== row.item
      })
    },
    addTelDirections () {
      if (!this.selectTelDir) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select telephone direction'), 'Error')
        return
      }
      for (let el of this.editItem.directions) {
        if (el.dir_id === this.selectTelDir.dir_id) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more telephone direction for same id'), 'Error')
          return
        }
      }
      this.editItem.directions.push(this.selectTelDir)
      this.$refs.modalAddTelephoneDirections.hide()
    },
    filterChanged (value) {
      this.filter = value
      if (this.currentPage === 1) {
        this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': this.perPage, 'offset': (this.currentPage - 1) * this.perPage, 'filter': value})
      } else {
        this.currentPage = 1
      }
    },
    shown () {
      this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': 20, 'offset': 0, 'filter': ''})
    }
  },
  watch: {
    currentPage (val) {
      this.$store.dispatch('Tariffing/GET_TEL_DIRECTIONS_LIST', {'count': this.perPage, 'offset': (val - 1) * this.perPage, 'filter': this.filter})
    }
  },
  computed: {
    telDirectionsItems () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_DIRECTIONS_LIST'])).items
      if (!this.isShowBusyDirections) {
        copy = copy.filter(elZone => {
          return elZone.zone_id === 0
        })
      }
      for (let el of copy) {
        for (let elZone of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_ZONES']))) {
          if (el.zone_id === elZone.zone_id) {
            el.zones = elZone.name + ' (' + elZone.zone_id + ')'
            break
          }
        }
      }
      return copy
    },
    telDirectionsTotal () {
      return JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_DIRECTIONS_LIST'].total))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/telephony/telephoneZones/editModal.vue